module.exports = __webpack_public_path__ + "static/media/adesivo_honda.6e2308f9.png";